module.exports = __webpack_public_path__ + "img/SY.a4ec6bbd.png";